export default __webpack_public_path__ + "static/realWorldImage1-0f16350479c17f665f30a6adce5a4016.webp";